import api from "@/lib/api";

const b64urlToBytes = (s) => {
  const pad = "===".slice((s.length + 3) % 4);
  const bin = atob(s.replace(/-/g, "+").replace(/_/g, "/") + pad);
  return Uint8Array.from(bin, (c) => c.charCodeAt(0));
};
const bytesToB64url = (buf) => {
  const s = String.fromCharCode(...new Uint8Array(buf));
  return btoa(s).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};
const toPublicKey = (o) => ({
  ...o,
  challenge: b64urlToBytes(o.challenge),
  user: o.user ? { ...o.user, id: b64urlToBytes(o.user.id) } : undefined,
  excludeCredentials: o.excludeCredentials?.map((c) => ({ ...c, id: b64urlToBytes(c.id) })),
  allowCredentials: o.allowCredentials?.map((c) => ({ ...c, id: b64urlToBytes(c.id) })),
});

export const biometricSupported = () =>
  typeof window !== "undefined" && !!window.PublicKeyCredential && !!(navigator.credentials && navigator.credentials.create);

export async function registerPasskey() {
  const { data } = await api.post("/passkeys/registration/options");
  const cred = await navigator.credentials.create({ publicKey: toPublicKey(data.options) });
  const a = cred.response;
  const body = {
    id: cred.id, rawId: bytesToB64url(cred.rawId), type: cred.type,
    response: {
      clientDataJSON: bytesToB64url(a.clientDataJSON),
      attestationObject: bytesToB64url(a.attestationObject),
      transports: a.getTransports ? a.getTransports() : [],
    },
    clientExtensionResults: cred.getClientExtensionResults(),
  };
  await api.post(`/passkeys/registration/verify?ceremony_id=${encodeURIComponent(data.ceremony_id)}`, body);
}

export async function authenticatePasskey(remember) {
  const { data } = await api.post("/passkeys/authentication/options", { remember_me: !!remember });
  const cred = await navigator.credentials.get({ publicKey: toPublicKey(data.options) });
  const a = cred.response;
  const body = {
    id: cred.id, rawId: bytesToB64url(cred.rawId), type: cred.type,
    response: {
      clientDataJSON: bytesToB64url(a.clientDataJSON),
      authenticatorData: bytesToB64url(a.authenticatorData),
      signature: bytesToB64url(a.signature),
      userHandle: a.userHandle ? bytesToB64url(a.userHandle) : null,
    },
    clientExtensionResults: cred.getClientExtensionResults(),
  };
  const res = await api.post(`/passkeys/authentication/verify?ceremony_id=${encodeURIComponent(data.ceremony_id)}`, body);
  return res.data; // { token, user }
}

export async function listPasskeys() {
  const { data } = await api.get("/passkeys");
  return data;
}
